import defaultLocale from "../../locale/en-US/index.js";
export default defaultLocale;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/_lib/defaultLocale/index.js
// module id = 546
// module chunks = 0